module.exports = __webpack_public_path__ + "static/media/right_active.638008cd.svg";